import { useAbility } from "@casl/vue";
import type { AppAbility } from "~/types/permissions";

export const useAppAbility = () => useAbility<AppAbility>();
